




















































































import { Component, Vue, Watch } from 'vue-property-decorator';
// Event bus
import { EventBus } from '@/event-bus';
import {
  DateSelection,
  SelectedOffer,
  BeneficiarySelection,
  RibUpload,
  SepaDebitMandate,
  PhoneSignature,
  ContractSidebar,
  SignatureModal,
  ValidationModal,
  NavButton,
  TitleWithStep,
  LegalRepresentative
} from '@/components';
import { ContractSubscriptionService } from '@/services';
import axios from 'axios';
import { UploadPayload } from '@/models/upload-payload.model';

import { client, collectiveAgreement, contractPreparation, offer, toastError } from '@/store';
import { pageName } from '@/router';
import { emitScrollToElement } from '@projetlucie/lc-front-sdk-old';

@Component({
  components: {
    DateSelection,
    SelectedOffer,
    BeneficiarySelection,
    PhoneSignature,
    RibUpload,
    ContractSidebar,
    SepaDebitMandate,
    SignatureModal,
    ValidationModal,
    NavButton,
    TitleWithStep,
    LegalRepresentative
  }
})
export default class ContractSubscription extends Vue {
  // #region Props
  private refs: any = this.$refs;
  private ribUploadPayload: UploadPayload = { successFiles: [], canFilesBeUploaded: false };
  private files: UploadPayload = { successFiles: [], canFilesBeUploaded: false };

  private isSendingData = false;
  private isDateValid = false;
  private isPhoneValid = false;
  private showRibUpload = false;
  private isValidRib = false;
  private isSigned = false;
  private isBeneficiary = false;
  private isValidEnterpriseInfo = false;
  private impossibleSignatureErrorMessage = `Les informations légales de l'entreprise n'ont pas pu être identifiées, merci de s'assurer qu'il s'agit bien de votre entreprise`;
  // #endregion

  // #region Getters
  get isAllFormValid() {
    return (
      this.isValidEnterpriseInfo && this.isBeneficiary && this.isValidRib && this.showRibUpload && this.isDateValid
    );
  }

  get comeFromSwiftRoute() {
    return contractPreparation.comeFromSwiftRoute;
  }

  get beneficiaries() {
    return offer.beneficiaries;
  }

  get contractStartDate() {
    return contractPreparation.contractStartDate;
  }

  get selectedDevis() {
    return contractPreparation.selectedDevis;
  }

  get legalRepresentative() {
    return contractPreparation.legalRepresentative;
  }

  get bankInfo() {
    return contractPreparation.bankInfo;
  }

  get phoneToSign() {
    return contractPreparation.phoneToSign;
  }

  get collectiveAgreement() {
    return collectiveAgreement.collectiveAgreement;
  }
  // #endregion

  async mounted() {
    contractPreparation.getLegalRepresentativesRoles();
    contractPreparation.getSepaMandat();

    await offer.getBasesByPropProfile({
      ccid: this.collectiveAgreement?.idAgreement,
      age: this.selectedDevis?.ageMoyen,
      zipCode: this.selectedDevis?.codePostal
    });
    //TODO: passer par un emit ou laisser le paretn gerer completement
    EventBus.$on('event-scroll', () => {
      this.ScrollToBottom();
    });
  }

  private handleFormStateCohesion() {
    if (!this.isDateValid) {
      this.resetAfterDate();
      return;
    }

    if (!this.isBeneficiary) {
      this.resetAfterBeneficiary();
      return;
    }

    if (!this.showRibUpload) {
      this.resetAfterRIB();
      return;
    }

    if (!this.isValidRib) {
      this.resetAfterSEPA();
      return;
    }

    if (!this.isValidEnterpriseInfo) {
      this.isPhoneValid = false;
      return;
    }
  }

  private resetAfterDate() {
    this.isBeneficiary = false;
    this.resetAfterBeneficiary();
  }

  private resetAfterBeneficiary() {
    this.showRibUpload = false;
    this.resetAfterRIB();
  }

  private resetAfterRIB() {
    this.isValidRib = false;
    this.resetAfterSEPA();
  }

  private resetAfterSEPA() {
    this.isValidEnterpriseInfo = false;
    this.isPhoneValid = false;
  }

  public async refreshViewContract() {
    await contractPreparation.refreshContractProject(this.beneficiaries);
    const sidebarContractRef: any = this.$refs.sidebarRef;
    await sidebarContractRef.setSideBarState(true);
  }

  ScrollToBottom() {
    emitScrollToElement(EventBus, this.$refs['anchorBottom'] as HTMLElement);
  }

  public preview() {
    contractPreparation.clearContractProject();
    if (!this.comeFromSwiftRoute || !client.enterprise) {
      this.$router.push(pageName.DevisList);
    } else {
      offer.resetOffers();
      contractPreparation.setSwiftRoute(false);
      this.$router.push(pageName.CreateNewDevis);
    }
  }

  public setInputFileRepresentative(legalFiles: UploadPayload): void {
    this.files = legalFiles;
    if (this.files.canFilesBeUploaded == false) {
      this.showRibUpload = false;
      this.isValidRib = false;
      this.ribUploadPayload = { successFiles: [], canFilesBeUploaded: false };
    }
  }

  public async submitLegalRep(legalFiles: UploadPayload) {
    this.showRibUpload = legalFiles !== null;
  }

  public async onRibValidationChanged(payload: any) {
    this.isValidRib = payload.isValid;
    this.ribUploadPayload = payload.uploadPayload;

    if (this.isValidRib && contractPreparation.selectedDevis) {
      this.isValidEnterpriseInfo = await ContractSubscriptionService.completeDevisWithSocieteInfos(
        contractPreparation.selectedDevis.id
      );
      if (!this.isValidEnterpriseInfo) {
        toastError.pushError(this.impossibleSignatureErrorMessage);
      } else {
        this.ScrollToBottom();
      }
    }
    this.handleFormStateCohesion();
  }

  public async submit() {
    if (!this.ribUploadPayload.canFilesBeUploaded) {
      return;
    }
    const resultsPhoneFormRes = await this.refs.phoneForm.submit();

    if (!resultsPhoneFormRes) return;

    if (this.isSendingData) return;

    this.isSendingData = true;

    this.startSignatureProcess();

    this.isSendingData = false;
  }
  private async submitOnEnter() {
    this.handleFormStateCohesion;
    await this.submit();
  }

  private async startSignatureProcess() {
    const filesBlobs = [];
    let ribFile: Blob = new Blob();
    let canDisplaySignatureModale = true;

    if (!this.selectedDevis) return toastError.pushError('Devis introuvable, merci de recommencer');

    try {
      for (const file of this.files.successFiles) {
        const blob = await axios.get(file.url, { responseType: 'blob' });
        filesBlobs.push(blob.data);
      }

      for (const file of this.ribUploadPayload.successFiles) {
        const blob = await axios.get(file.url, { responseType: 'blob' });
        ribFile = blob.data;
      }

      const startSignatureResponse = await ContractSubscriptionService.startSignature(
        this.selectedDevis.id,
        this.contractStartDate,
        this.legalRepresentative.email.trim(),
        this.legalRepresentative.name.trim(),
        this.legalRepresentative.lastName.trim(),
        this.legalRepresentative.role.id,
        this.bankInfo.titulaire.trim(),
        this.bankInfo.iban.trim(),
        this.bankInfo.bic.trim(),
        filesBlobs,
        ribFile,
        this.beneficiaries
      );

      if (!startSignatureResponse) {
        return;
      }

      const sendSmsResponse = await ContractSubscriptionService.sendSms(this.selectedDevis.id, this.phoneToSign);
      if (!sendSmsResponse) {
        return;
      }
    } catch (error) {
      console.log(error);
      canDisplaySignatureModale = false;
    }
    if (canDisplaySignatureModale) {
      this.openSignatureModale();
      return;
    }
    return;
  }

  public openSignatureModale() {
    this.refs.signatureModal.setModalState(true);
  }

  public closeSignatureModale() {
    this.refs.signatureModal.setModalState(false);
  }

  @Watch('isSigned')
  public openValidationModale() {
    const validationModalRef: any = this.refs.validationModal;
    if (this.isSigned) {
      validationModalRef.setModalState(true);
      this.closeSignatureModale();
    }
  }
}
